import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import TourOneTabView from './tab-views/tour-one/TourOneTabView';
import TourTwoTabView from './tab-views/tour-two/TourTwoTabView';
import TourThreeTabView from './tab-views/tour-three/TourThreeTabView';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/system';
import { useLocation } from 'react-router';
import TourFourTabView from './tab-views/tour-four/TourFourTabView';
import { useSearchParams } from 'react-router-dom';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index &&
                children
            }
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

function useQuery() {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
}

const ToursTab = () => {
    const [tourId, setTourId] = React.useState(0);
    const { t } = useTranslation();
    const [searchParams, setSearchParams] = useSearchParams();

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setSearchParams({ ["tourId"]: `${newValue + 1}` })
        setTourId(newValue);
    };



    let query = useQuery();
    React.useEffect(() => {
        var tourId = query.get("tourId");
        if (tourId !== undefined && tourId !== null && (tourId === "1" || tourId === "2" || tourId === "3" || tourId === "4")) {
            setTourId(Number(tourId) - 1);
        }
    }, []);

    return (
        <Box sx={{ width: '100%' }}>
            <Box
                mb={{ xs: 3, md: 5 }}
                sx={{
                    p: { xs: 0.6, sm: 0.75 },
                    borderRadius: 999,
                    background: "rgba(16, 18, 20, 0.82)",
                    border: "1px solid rgba(255, 255, 255, 0.08)",
                    boxShadow: "inset 0 1px 0 rgba(255, 255, 255, 0.05), 0 18px 42px rgba(0, 0, 0, 0.22)",
                    backdropFilter: "blur(14px)"
                }}>
                <Tabs
                    centered
                    value={tourId}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                    variant='fullWidth'
                    sx={{
                        minHeight: 0,
                        "& .MuiTabs-flexContainer": {
                            gap: { xs: 0.5, sm: 0.75 }
                        },
                        "& .MuiTabs-indicator": {
                            display: "none"
                        }
                    }}>
                    <StyledTab label={t("tour.tour1")} {...a11yProps(0)} />
                    <StyledTab label={t("tour.tour2")} {...a11yProps(1)} />
                    <StyledTab label={t("tour.tour3")} {...a11yProps(2)} />
                    <StyledTab label={t("tour.tour4")} {...a11yProps(3)} />
                </Tabs>
            </Box>
            <CustomTabPanel value={tourId} index={0}>
                <TourOneTabView />
            </CustomTabPanel>
            <CustomTabPanel value={tourId} index={1}>
                <TourTwoTabView />
            </CustomTabPanel>
            <CustomTabPanel value={tourId} index={2}>
                <TourThreeTabView />
            </CustomTabPanel>
            <CustomTabPanel value={tourId} index={3}>
                <TourFourTabView />
            </CustomTabPanel>
        </Box>
    );
}

export default ToursTab;


interface StyledTabProps {
    label: string;
}

const StyledTab = styled((props: StyledTabProps) => <Tab disableRipple {...props} />)(
    ({ theme }) => ({
        textTransform: 'none',
        minWidth: 0,
        minHeight: 0,
        [theme.breakpoints.up('sm')]: {
            minWidth: 0,
        },
        paddingTop: theme.spacing(1.6),
        paddingBottom: theme.spacing(1.6),
        borderRadius: 999,
        border: "1px solid transparent",
        fontWeight: 700,
        fontSize: 15,
        letterSpacing: 0.2,
        [theme.breakpoints.down('sm')]: {
            paddingTop: theme.spacing(1.2),
            paddingBottom: theme.spacing(1.2),
            fontSize: 13,
            borderRadius: 12,
        },
        background: "transparent",
        boxShadow: "none",
        color: 'rgba(233, 233, 233, 0.72)',
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
        '&:hover': {
            color: "#fff",
            background: "rgba(255, 255, 255, 0.06)",
            opacity: 1,
        },
        '&.Mui-selected': {
            color: "#fff",
            borderColor: "rgba(255, 255, 255, 0.1)",
            background: "linear-gradient(135deg, #df5c2d, #f07a45)",
            boxShadow: "inset 0 1px 0 rgba(255, 255, 255, 0.18)",
            fontWeight: 800
        },
        '&.Mui-focusVisible': {
            outline: `2px solid ${theme.palette.primary.light}`,
            outlineOffset: 2,
        },
    }),
);